import { helper } from '@ember/component/helper';
import { DateTime } from 'scaleflow/utils/date-time';

export default helper(function convertDateFormat([dateInYYYYMMDD, format]) {
  return DateTime.parse(dateInYYYYMMDD, 'YYYY-MM-DD').format(format);
});
